define(['display/map'], function(L) {
    function onPropertyChange(e) {
        this.geopolViewService.setCurrentGeopolView(e.target.value);
    }

    function addOptions(select, values) {
        var option;
        values.forEach(function(value) {
            option = document.createElement('option');
            option.text = value.getLabel();
            option.value = value.getCode();
            select.add(option);
        });
    }

    function setCurrentGeopolView(select) {
        var i;
        var geopolViewVal = select.geopolViewService.current.code;
        for (i = 0; i < select.options.length; ++i) {
            if (select.options[i].value === geopolViewVal) {
                select.selectedIndex = i;
            }
        }
    }
    /**
     * A module, which helps you to create language selector
     * @module Widgets
     * @class geopolViewSelector
     */
    return {
        /**
         * Options are set for supported geopolViews, onchange event has a bound function,
         * which updates global geopolView for the system (which is stored in GeopolViewService.
         * Refer to https://developer.mozilla.org/en/docs/Web/API/HTMLSelectElement for additional information.
         * @method getHtmlElement
         * @param {GeopolViewService} [geopolViewService] GeopolViewService which will be bound to this select element.
         * That means, that if you change value in this select, bound geopolViewService will be updated. You can provide
         * globalGeopolViewService or geopolViewServices which are bound to map instances.
         * @param {"search"|"maps"|"geopolViewSelector"} serviceType
         * @param {"raster"|"vector"} [subType] Used to specify the subType of a service,
         * @returns {HTMLSelectElement}
         */
        getHtmlElement: function(geopolViewService, serviceType, subType) {
            var select;
            if (!geopolViewService) {
                console.error('GeopolViewService not passed to geopolViewSelector!');
                return undefined;
            }
            select = document.createElement('select');
            select.geopolViewService = geopolViewService;
            select.className = 'tomtom-geopol-view-selector';
            addOptions(select, L.GeopolViewService.getSupportedViews(serviceType, subType));
            setCurrentGeopolView(select);
            select.addEventListener('change', onPropertyChange);
            return select;
        }
    };
});



// WEBPACK FOOTER //
// ./widgets/controls/geopolViewSelector.js